import { useReducer } from 'react';
import constate from 'constate';
import merge from 'lodash/merge';
import repo from 'service/repository';
import localDataService from 'service/local-data-service';
import { createReducer } from 'utils/reducers-helper';
import { useHistory } from 'react-router-dom';
import { PATHS } from 'config';

export const CHANGE_DISTRIBUTOR = 'CHANGE_DISTRIBUTOR';
export const DETECT_MOBILE = 'DETECT_MOBILE';
export const DETECT_CODE = 'DETECT_CODE';
export const IS_MEMBER = 'IS_MEMBER';
export const IS_NOT_MEMBER = 'IS_NOT_MEMBER';
export const OTP_COUNT_DOWN = 'OTP_COUNT_DOWN';
export const OTP_COUNT_DOWN_END = 'OTP_COUNT_DOWN_END';
export const RESEND_OTP = 'RESEND_OTP';
export const CODE_ERROR = 'CODE_ERROR';
export const DOWNLOAD_PAGE_IN = 'DOWNLOAD_PAGE_IN';
export const FINISH_LOGIN = 'FINISH_LOGIN';
export const GO_BACK = 'GO_BACK';
export const RESET_DIALOG = 'RESET_DIALOG';

const useLightBoxLogin = () => {
  const history = useHistory();

  const initState = {
    currentDistributor: 'AUTOPASS',
    mobile: '',
    mobileAvailable: false,
    isMember: true,
    code: '',
    codeAvailable: false,
    codeErrorMsg: '',

    otpCountDownTime: 80,
    otpCountDownStart: false,

    mobilePageOut: false,
    codePageIn: false,
    codePageOut: false,
    successPageIn: false,
    downloadPageIn: false,
    cancelLightboxClose: false,
  };

  const changingDistributor = key => {
    dispatch({
      type: CHANGE_DISTRIBUTOR,
      payload: key,
    });
  };

  const changeDistributor = (state, payload) => {
    return merge({}, state, { currentDistributor: payload });
  };

  const detectMobile = (state, payload) => {
    const mobileAvailable = payload.match('^09[0-9]{8}$') ? true : false;

    return merge({}, state, {
      mobile: payload,
      mobileAvailable,
    });
  };

  const detectCode = (state, payload) => {
    const codeAvailable = payload.match('^[0-9]{6}$') ? true : false;
    return merge({}, state, {
      code: payload,
      codeAvailable,
    });
  };

  const codeError = state => merge({}, state, { codeErrorMsg: '簡訊驗證碼錯誤' });

  const isMember = state =>
    merge({}, state, {
      mobilePageOut: true,
      codePageIn: true,
      otpCountDownStart: true,
    });

  const isNotMember = state => merge({}, state, { isMember: false });

  const otpCountDown = state => {
    let t = state.otpCountDownTime;
    return merge({}, state, { otpCountDownTime: t - 1 });
  };
  const otpCountDownEnd = state =>
    merge({}, state, {
      otpCountDownStart: false,
      otpCountDownTime: 80,
    });
  const resendOtp = state => merge({}, state, { otpCountDownStart: true });

  const downloadPageIn = state =>
    merge({}, state, {
      mobilePageOut: true,
      downloadPageIn: true,
      codePageOut: true,
    });

  const finishLogin = state =>
    merge({}, state, {
      codePageOut: true,
      successPageIn: true,
      codeErrorMsg: undefined,
      cancelLightboxClose: true,
      otpCountDownStart: false,
    });

  const goBack = state =>
    merge({}, state, {
      mobilePageOut: false,
      codePageIn: false,
      codePageOut: false,
      downloadPageIn: false,
      isMember: true,
      otpCountDownTime: 80,
      otpCountDownStart: false,
      code: '',
      codeAvailable: false,
      codeErrorMsg: '',
    });

  const resetDialog = () => initState;

  const reducer = createReducer(
    {
      [CHANGE_DISTRIBUTOR]: changeDistributor,
      [DETECT_MOBILE]: detectMobile,
      [DETECT_CODE]: detectCode,
      [IS_MEMBER]: isMember,
      [IS_NOT_MEMBER]: isNotMember,
      [OTP_COUNT_DOWN]: otpCountDown,
      [OTP_COUNT_DOWN_END]: otpCountDownEnd,
      [RESEND_OTP]: resendOtp,
      [CODE_ERROR]: codeError,
      [DOWNLOAD_PAGE_IN]: downloadPageIn,
      [FINISH_LOGIN]: finishLogin,
      [GO_BACK]: goBack,
      [RESET_DIALOG]: resetDialog,
    },
    initState
  );

  const [state, dispatch] = useReducer(reducer, initState);

  const onSendMobile = async () => {
    const [err] = await repo.fetchOtp(state.currentDistributor, state.mobile);

    if (err) {
      dispatch({ type: IS_NOT_MEMBER });
      dispatch({ type: DOWNLOAD_PAGE_IN });
    } else {
      dispatch({ type: IS_MEMBER });
    }
  };

  const onResendOtp = async () => {
    await repo.fetchOtp(state.mobile);
    dispatch({ type: RESEND_OTP });
  };

  const onSendCode = async closeLightBox => {
    const [err, data] = await repo.fetchAuth(state.currentDistributor, state.mobile, state.code);

    if (err) {
      dispatch({ type: CODE_ERROR });
    } else {
      localDataService.saveAuth(data);
      dispatch({ type: FINISH_LOGIN });
      setTimeout(() => {
        history.push({ pathname: PATHS.USER, search: `tab=profile` });
        closeLightBox();
      }, 2300);
      setTimeout(() => {
        dispatch({ type: RESET_DIALOG });
      }, 2600);
    }
  };

  return { state, dispatch, onSendMobile, onSendCode, onResendOtp, changingDistributor };
};

const [LightBoxLoginProvider, useLightBoxLoginContext] = constate(useLightBoxLogin);

export { LightBoxLoginProvider, useLightBoxLoginContext };
